import { combineReducers } from '@reduxjs/toolkit';

import { oauthSlice } from './oauth/oauthSlice';
import { vehiclesSlice } from './catalog/vehiclesSlice';
import { subscriptionsSlice } from './subscriptions/subscriptionsSlice';
import { bookingsSlice } from './bookings/bookingsSlice';
import { notificationsSlice } from './notifications/notificationsSlice';
import { layoutSlice } from './layout/layoutSlice';
import { arnmAccidentsSlice } from './arnmAccidents/arnmAccidentsSlice';
import { arnmRepairsSlice } from './arnmRepairs/arnmRepairsSlice';
import { arnmMaintenanceSlice } from './arnmMaintenance/arnmMaintenanceSlice';
import { ebikesSlice } from './ebike/ebikeSlice';
import { availabilityTableSlice } from './availabilityTable/availabilityTableSlice';
import { sellVehiclesSlice } from './sellVehicles/sellVehiclesSlice';
import { communicationSlice } from './communication/communicationSlice';
import { logisticsSlice } from './logistics/logisticsSlice';
import { myIssuesMailboxSlice } from './myIssuesMailbox/myIssuesMailboxSlice';
import { sellRequestsSlice } from './sellRequests/sellRequestsSlice';

/* ui grid setting */
import { uiSettingsSlice } from './uiSettings/uiSettingsSlice';

const rootReducer = combineReducers({
  [oauthSlice.name]: oauthSlice.reducer,
  [vehiclesSlice.name]: vehiclesSlice.reducer,
  [subscriptionsSlice.name]: subscriptionsSlice.reducer,
  [bookingsSlice.name]: bookingsSlice.reducer,
  [notificationsSlice.name]: notificationsSlice.reducer,
  [layoutSlice.name]: layoutSlice.reducer,
  [arnmAccidentsSlice.name]: arnmAccidentsSlice.reducer,
  [arnmRepairsSlice.name]: arnmRepairsSlice.reducer,
  [arnmMaintenanceSlice.name]: arnmMaintenanceSlice.reducer,
  [ebikesSlice.name]: ebikesSlice.reducer,
  [uiSettingsSlice.name]: uiSettingsSlice.reducer,
  [availabilityTableSlice.name]: availabilityTableSlice.reducer,
  [sellVehiclesSlice.name]: sellVehiclesSlice.reducer,
  [communicationSlice.name]: communicationSlice.reducer,
  [logisticsSlice.name]: logisticsSlice.reducer,
  [myIssuesMailboxSlice.name]: myIssuesMailboxSlice.reducer,
  [sellRequestsSlice.name]: sellRequestsSlice.reducer,
});

export default rootReducer;
